// removed by extract-text-webpack-plugin
module.exports = {"list":"src-components-ReviewList----index-module---list---3r2kB","item":"src-components-ReviewList----index-module---item---3v1CI","text":"src-components-ReviewList----index-module---text---ElXp6 src-global-styles----content---textSerif---2B2hn","source":"src-components-ReviewList----index-module---source---1i6q4 src-global-styles----content---title---1yv3A"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReviewList/index.module.css
// module id = 305
// module chunks = 16550220580097